import * as React from "react";
import axios from "axios";
import apiconfig from "../../../../../config/api-config.js";
import { connect, useSelector } from "react-redux";
import {
  fetchSavedPlaylists,
  addToPlaylist,
  loadLocalPlaylist,
} from "../../../../FlikTraxStore/Actions/userActions";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import PlaylistAddIcon from "@mui/icons-material/FeaturedPlayList";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddToSavedPlaylist = (props) => {
  const userAuthenticated = useSelector(
    (state) => state.user && state.user.isAuthenticated
  );

  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [value, setValue] = React.useState();

  const [listtitle, setListTitle] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const handleChange = (event) => {
    setListTitle(event.target.id);
    setValue(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { enqueueSnackbar } = useSnackbar();

  const Notify = (notification) => {
    enqueueSnackbar(notification, { variant: "success" });
  };

  const saveToPlaylist = (event) => {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "addsaved",
        userid: props.user.user.username,
        track_title: listtitle,
        trackid: props.trackID,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      let msg = "Added " + props.trackTitle + " to " + listtitle;
      Notify(msg);
      handleClose();
    });
  };

  const handleClickOpen = () => {
    if (!userAuthenticated) {
      navigate("/login");
    }

    setOpen(true);
    setLoading(true);
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "fetchsaved",
        userid: props.user.user.username,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      //console.log(response.data); return;

      if (response.data[0] === undefined) {
        setPlaylists([]);
        fetchSavedPlaylists();
      } else {
        setPlaylists(response.data);
        setValue(response.data[0].ID);
      }
      setLoading(false);
    });
  };

  const [playlists, setPlaylists] = React.useState([]);

  let dataTitle = "";

  return (
    <React.Fragment>
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        title="Add To Saved Playlist"
        placement="top"
        arrow
      >
        <IconButton
          onClick={handleClickOpen}
          sx={{ padding: 1 }}
          size="small"
          aria-label="Add To Playlist"
          color="success"
        >
          <PlaylistAddIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          style: {
            color: "#fff",
            backgroundColor: "#272727",
            borderStyle: "solid",
            borderColor: "#7f7f7f",
            borderWidth: 1,
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <PlaylistAddIcon style={{ marginRight: 15 }} />
          {"Add To Saved Playlist"}
          <img
            src="/images/logos/The-Precinct-LOGO.webp"
            style={{ float: "right", maxWidth: 75 }}
          />
        </DialogTitle>
        <Box style={{ marginLeft: 25 }}>
          <h3>{props.trackTitle}</h3>
        </Box>
        <Divider style={{ color: "white" }} />
        <DialogContent>
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress color="inherit" />
            </Box>
          )}

          {playlists && playlists.length === 0 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              You Have No Saved Playlists
            </Box>
          )}

          <FormControl style={{ padding: 15 }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              {playlists &&
                playlists.length > 0 &&
                playlists.map((data, key) => {
                  return (
                    <>
                      <FormControlLabel
                        // disabled={
                        //   props.playlistTitle === data.title ? "disabled" : ""
                        // }
                        value={data.ID}
                        id={data.title}
                        control={
                          <Radio
                            id={data.title}
                            disabled={
                              props.playlistTitle === data.title
                                ? 'disabled="disabled"'
                                : ""
                            }
                            sx={{
                              "&, &.Mui-checked": {
                                color:
                                  props.playlistTitle !== data.title
                                    ? "whitesmoke"
                                    : "grey",
                              },
                            }}
                          />
                        }
                        label={data.title.toUpperCase()}
                      />
                    </>
                  );
                })}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <Divider style={{ color: "white" }} />
        <DialogActions>
          <Button style={{ backgroundColor: "#686868" }} onClick={handleClose}>
            {playlists && playlists.length === 0 ? "OK" : "CANCEL"}
          </Button>
          {playlists && playlists.length > 0 && (
            <Button
              disabled={listtitle === "" ? 'disabled="disabled"' : ""}
              //disabled="disabled"
              style={{ backgroundColor: "#686868" }}
              onClick={saveToPlaylist}
            >
              SAVE
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    api: state.api,
    user: state.user,
  };
}

export default connect(mapStateToProps, { fetchSavedPlaylists })(
  AddToSavedPlaylist
);
